module.exports = __webpack_public_path__ + "img/card.5583f5be.png";